/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import Globals from "../shared/Globals";
import Address from "./Address";
import { SidebarGlobal } from "./Sidebar";
import MessageDialog from "./MessageDialog";
import UploadImage from "./UploadImage";
import React from "react";

class PracticeView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                address: {}
            }
        };
        if (this.props.params.id) {
            this.id = this.props.params.id;
            this.state.loading = true;
        }

        this.submitRef = React.createRef();

        this.submit = this.submit.bind(this);
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={() => this.submitRef.current?.click()}><FontAwesomeIcon icon={fa.faSave} /> Save</button></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        if (this.id) {
            qreq.get('/api/practice/get/' + this.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {

    }

    submit(e) {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };


        this.setState({ saving: true });


        qreq.post('/api/practice/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1>Practices</h1><LoadingAlert /></div>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Practices</h1>
                <Breadcrumb path={[['Practices', '/practice/list'], [this.id ? 'Edit' : 'New']]} />
                <div className="row">
                    <div className="col-lg-12">
                        <Card title="Practice Info">
                            <FormInput model={this.state.item} name="name" label="Practice Name" type="text" required />
                            <div className="row">
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="phone" label="Phone" type="text" />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="fax" label="Fax" type="text" />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="contactName" label="Contact Name" type="text" />
                                </div>
                            </div>
                        </Card>
                        <Card title="Operating Credentials">
                            <div className="row">
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="npi" label="NPI" type="text" />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="tin" label="TIN" type="text" />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="ptan" label="PTAN" type="text" />
                                </div>
                            </div>
                        </Card>
                        <Address title="Address" item={this.state.item.address} required={false} />
                    </div>
                </div>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                    <div className="d-none">
                        <button ref={this.submitRef} id="c-submit" type="submit" className="btn btn-success d-inline-block">Save</button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}>Cancel and Go Back</button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(PracticeView);